<template>
  <StdioAuthCallback />
</template>

<script setup lang="ts">
import StdioAuthCallback from '@/components/auth/callback.vue'
</script>
